<template>
	<div class='plots-vb-tax-add-block'>
		
		<div class='title-block'>
			<span class='title'>Формирование фактического породного состава</span>
			<button @click='toggleAddBlock' class='show-btn'>{{ isOpen ? '-' : '+' }}</button>
		</div>

		<template v-if='isOpen'>

		<div class='layer-list-block' v-if='!addLayerMode'>
			<span>Выберите нужный ярус</span>
			<div
				class='layer-num-btn'
				v-for='itemLayer in lpoVisualLayerList'
				:class='{ selected: selectedLayer && itemLayer.layer_id === selectedLayer.layer_id }'
				@click='selectLayer(itemLayer)'
			>
				<span>{{ itemLayer.layer == "11" ? "Ед.деревья": itemLayer.layer}}</span>
			</div>

			<button :disabled="!actLpoIsDraft" @click='enableAddLayerMode'>
				<span class='need-margin-right'><i class='fa fa-plus '></i></span>
				<span>Ярус</span>
			</button>
			<button :disabled="!actLpoIsDraft" @click='enableAddLayerModeEd'>
				<span class='need-margin-right'><i class='fa fa-plus '></i></span>
				<span>Ярус ед.деревьев</span>
			</button>
		</div>

		<div class='layer-block' v-if='addLayerMode'>
			<span class='title'>Добавление нового яруса</span>
			<div class='flex-container'>
				<div>
					<span>Состав</span>
					<custom-p-input v-model='layerValues.composition'/>
				</div>
				<div>
					<span>Полнота</span>
					<custom-p-input v-model='layerValues.fullness' type='number'/>
				</div>
				<div>
					<span>Запас</span>
					<custom-p-input v-model='layerValues.stock' type='number'/>
				</div>

				<div class='layer-btn-block'>
					<button @click='cancelSaveLayer'>Отмена</button>
					<button v-if='addLayerModeEd' @click='saveLayer(11)'>Сохранить(ед)</button>
					<button v-else @click='saveLayer()'>Сохранить</button>
				</div>
			</div>
		</div>
		


		<div class='species-block' v-if='selectedLayer && !addLayerMode && lpoVisualLayerList.length'>
			<span class='title'>{{ selectedLayer.layer == "11" ? "Добавление породы в единичные деревья": `Добавление породы в ярус ${selectedLayer.layer}`   }}</span>
			<div class='flex-container'>
				<div>
					<span>Порода</span>
					<custom-p-select
						v-model='speciesValues.species'
						:options="info_species"
						:dataKey='null'
					/>
				</div>
				<div>
					<span>Сокращенное название</span>
					<custom-p-select
						v-model='speciesValues.name_short'
						:options="info_name_short"
						:optionLabel='null'
						:dataKey='null'
					/>
				</div>
				
				<div>
					<span>Доля</span>
					<custom-p-input v-model='speciesValues.coeff' type='text'/>
				</div>
				<div>
					<span>Поколение</span>
					<custom-p-input v-model='speciesValues.gen' type='number'/>
				</div>
				<div>
					<span>Возраст</span>
					<custom-p-input v-model='speciesValues.age' type='number'/>
				</div>
				<div>
					<span>Высота</span>
					<custom-p-input v-model='speciesValues.h' type='number'/>
				</div>
				<div>
					<span>Диаметр</span>
					<custom-p-input v-model='speciesValues.d' type='number'/>
				</div>

				<div class='species-btn-block'>
					<button :disabled="!actLpoIsDraft" @click='saveSpecies'>Сохранить</button>
				</div>
			</div>
		</div>

		</template>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	export default {
		name: 'PlotsVbTaxAddBlock',
		data: () => ({
			layerValues: {
				composition: null,
				fullness: null,
				stock: null,
			},
			speciesValues: {
				species: null,
				name_short: null,
				coeff: null,
				gen: null,
				age: null,
				h: null,
				d: null,
			},

			addLayerMode: false,
			addLayerModeEd: false,
			selectedLayer: null,

			isOpen: true,
		}),
		computed: {
			addedSpecies_species() {
				return this.speciesValues.species;
			},	

			...mapState('selectedLpo', {
				info_species_name_short: state => state.info_species_name_short
			}),

			...mapGetters('selectedLpo', [
				'lpoVisualLayerList',
				'lpoVisualLayerSpeciesList'
			]),
			...mapGetters('lpoData', ['actLpoIsDraft'
			]),
			...mapState({
				info_species: state => state.catalogs['info_species']
			}),

			info_name_short() {
				return this.info_species_name_short.map(item => item.name);
			},
		},
		watch: {
			lpoVisualLayerList(lpoVisualLayerList) {
				if (lpoVisualLayerList.length && !this.selectedLayer) {
					this.selectedLayer = lpoVisualLayerList[0];
				}
			},

			addedSpecies_species(val) {
				// console.log(val);
				// return;
				if (val) {
					this.getSpeciesNameShort(val);
				} else {
					this.$store.commit('selectedLpo/setSpeciesNameShort', []);
				}

				this.speciesValues.name_short = null;
			},
		},
		methods: {
			toggleAddBlock() {
				this.isOpen = !this.isOpen;
			},

			selectLayer(layer) {
				this.selectedLayer = layer;
			},

			enableAddLayerMode() {
				this.addLayerMode = true;
				this.layerValues =  {
					composition: null,
					fullness: null,
					stock: null,
				};
			},
			enableAddLayerModeEd() {
				this.enableAddLayerMode();
				this.addLayerModeEd = true;
				this.layerValues =  {
					composition: null,
					fullness: null,
					stock: null,
				};
			},
			disableAddLayerMode() {
				this.addLayerMode = false;
			},
			disableAddLayerModeEd() {
				this.disableAddLayerMode();
				this.addLayerModeEd = false;
			},
			saveLayer(layer_num=null) {
				console.log("start")
				const temp = this.layerValues
				temp.layer = layer_num
				if (layer_num == 11) {
					temp.composition = `единичные деревья ${temp.composition}`;
				}
				console.log(temp)
				this.addLpoVisualLayer(temp).then(res => {
					
					return this.updateVisualSpecies().then(res => {
						if (this.lpoVisualLayerList.length === 1) {
							this.selectLayer(this.lpoVisualLayerList[0]);
						}
						this.addLayerMode = false;
						this.addLayerModeEd = false;
					});
				}).catch(err => {
					this.$toast.add({severity: 'warn', detail: err.message, life: 10000});
					throw err;
				});
				console.log("finish")
			},
			cancelSaveLayer() {
				this.disableAddLayerMode();
				this.disableAddLayerModeEd();
			},

			saveSpecies() {
				
				const payload = {
					layer: this.selectedLayer,
					species: this.speciesValues
				};
				this.addLpoVisualSpecies(payload).then(res => {
					this.speciesValues = {
						species: null,
						name_short: null,
						coeff: null,
						gen: null,
						age: null,
						h: null,
						d: null,
					}
					return this.updateVisualSpecies();
				}).catch(err => {
					this.$toast.add({severity: 'warn', detail: err.message, life: 10000});
					throw err;
				});
				// this.addLpoVisualLayer(this.layerValues);
			},

			...mapActions('selectedLpo', [
				'addLpoVisualLayer',
				'updateVisualSpecies',
				'getSpeciesNameShort',
				'addLpoVisualSpecies',
			]),
			...mapActions([
				'loadCatalogs'
			])
		},
		created() {
			const catalogs = [ 'info_species' ];
			this.loadCatalogs(catalogs);

			if (this.lpoVisualLayerList.length) {
				this.selectedLayer = this.lpoVisualLayerList[0];
			}
		}
	};
</script>

<style scoped src='@/style/flex.css'></style>
<style scoped src='@/style/input.css'></style>

<style scoped>
	.flex-container {
		gap: 1rem;

	}
	.flex-container > div {
		width: 30%;
	}

	.plots-vb-tax-add-block {
		border: 1px solid #888;
		padding: 1rem;
	}

	.title-block {
		/*margin-bottom: 1rem;*/
	}

	.title-block::after {
		content: '';
		clear: both;
		display: table;
	}

	.title-block > .title {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.title-block > .show-btn {
		float: right;
	}

	.layer-block,
	.species-block {
		padding: 0 4rem;
		margin-top: 1rem;
	}

	.layer-block > .title,
	.species-block > .title {
		font-size: 1rem;
		font-weight: bold;
		font-style: italic;
		display: inline-block;
		margin-bottom: 1rem;
	}

	.layer-list-block {
		/*border: 1px solid black;*/
		display: flex;
		gap: 0.5rem;
		margin-top: 1rem;
		align-items: center;
  	/*justify-content: center;*/
	}
	.layer-num-btn {
		padding: 0.4rem 0.6rem;
		cursor: pointer;
		border: 1px solid black;
		border-radius: 4px;
	}
	.layer-num-btn:hover {
		background-color: #ddd;
		transition: all 0.2s ease;
	}
	.layer-num-btn.selected {
		background-color: black;
		color: white;
	}
	.add-new-layer-btn {
		padding: 0.4rem 0.6rem;
		background-color: #eee;
		cursor: pointer;
		border: 1px solid #999;
		border-radius: 4px;
	}
	.add-new-layer-btn:hover {
		background-color: #ddd;
		transition: all 0.2s ease;
	}

	.need-margin-right {
		margin-right: 0.8rem;
	}

	.layer-btn-block > button:first-child{
		margin-right: 0.5rem;
	}
</style>